import { render, staticRenderFns } from "./DiscountSheet.vue?vue&type=template&id=28ce9c20&scoped=true"
import script from "./DiscountSheet.vue?vue&type=script&lang=js"
export * from "./DiscountSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce9c20",
  null
  
)

export default component.exports